import { ReportMaintenance, ReportAssets, ReportRepair, ReportRecommendations, ReportPengadaan } from "@/components/ReportTables";

function Page({ title, subtitle, testid, children }) {
  return (
    <div data-testid={testid} className="space-y-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-heading font-semibold tracking-tight">{title}</h1>
        <p className="text-sm text-muted-foreground">{subtitle}</p>
      </div>
      {children}
    </div>
  );
}

export function LaporanPerbaikan() {
  return (
    <Page title="Laporan Perbaikan" subtitle="Aset dalam perbaikan dan rekomendasi perbaikan dari tim IT." testid="pimpinan-laporan-perbaikan">
      <div className="space-y-10">
        <ReportRepair />
        <ReportRecommendations />
      </div>
    </Page>
  );
}

export function LaporanMaintenance() {
  return (
    <Page title="Laporan Maintenance" subtitle="Pekerjaan maintenance yang dilakukan IT berdasarkan jadwal." testid="pimpinan-laporan-maintenance">
      <ReportMaintenance />
    </Page>
  );
}

export function LaporanPengadaan() {
  return (
    <Page title="Laporan Rekomendasi" subtitle="Rekomendasi aset yang diajukan untuk keperluan rumah sakit." testid="pimpinan-laporan-pengadaan">
      <ReportPengadaan canApprove />
    </Page>
  );
}

export function LaporanAset() {
  return (
    <Page title="Laporan Aset" subtitle="Data keseluruhan aset peralatan IT di rumah sakit." testid="pimpinan-laporan-aset">
      <ReportAssets />
    </Page>
  );
}
